module.exports = __webpack_public_path__ + "img/3A2412_A78B5F_705434_836C47-256px.fad02bf0.png";